// extracted by mini-css-extract-plugin
export default {"researcher":"Researcher_researcher__jptWZ","head":"Researcher_head__P3fLE","buttons":"Researcher_buttons__oXRHI","choice":"Researcher_choice__FurfB"};